module.exports = __webpack_public_path__ + "static/color-silver.eeb25f23.png";